// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactsPage-module--root--2cOwK","inner":"ContactsPage-module--inner--1xqAg","title":"ContactsPage-module--title--2MEf3","contacts":"ContactsPage-module--contacts--279bI"};